import { render, staticRenderFns } from "./ControleerSection.vue?vue&type=template&id=89b4a652&scoped=true"
import script from "./ControleerSection.vue?vue&type=script&lang=js"
export * from "./ControleerSection.vue?vue&type=script&lang=js"
import style0 from "./ControleerSection.vue?vue&type=style&index=0&id=89b4a652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b4a652",
  null
  
)

export default component.exports